import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { companySiteApiClient } from '@src/api/company/site/companySiteApiClient';
import { COMPANY_URL } from '@src/routes/company';
import Button from '@src/ui/elements/button/Button';
import { useEffect, useState } from 'react';

function RegistrationRequiresApproval() {
  const [topPageLink, setTopPageLink] = useState(COMPANY_URL.ARTICLES);

  useEffect(() => {
    const setupTopPageUrl = async () => {
      const res = await companySiteApiClient.topPageUrl();
      handleApiResponse(res, (data) => {
        setTopPageLink(data.url);
      });
    };
    setupTopPageUrl();
  }, []);

  return (
    <div className='text-center'>
      <h1 className='mb-1 text-primary-500'>会員登録承認手続を受付ました。</h1>
      <p className='mb-7 text-lg font-semibold text-[#222222]'>メールをご確認ください。</p>
      <div className='mx-auto max-w-[400px]'>
        <Button
          href={topPageLink}
          size='m'
          variant='primary'
          outline
          fullWidth
          fullRounded
        >
          トップページに戻る
        </Button>
      </div>
    </div>
  );
}

export default RegistrationRequiresApproval;
